function newsSlider() {

  const newsSliderImage = new Swiper('.js-news-slider-image', {
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide',
    slidesPerView: 1,
    spaceBetween: 10,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
  });

  const newsSliderText = new Swiper('.js-news-slider-text', {
    loop: true,
    draggable: true,
    allowTouchMove: true,
    effect: 'slide', 
    slidesPerView: 1,
    spaceBetween: 10,
  });

  newsSliderImage.controller.control = newsSliderText;
  newsSliderText.controller.control = newsSliderImage;
}


export default newsSlider;
